import React from "react";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import { styled } from "styled-components";
import MainPage from "./Pages/MainPage";
import ContactPage from "./Pages/ContactPage";
import SelfSummary from "./Components/SelfSummary";
import AboutMe from "./Pages/AboutMe";
import { Column } from "./Styles/StyledComponents";
import Footer from "./Components/Footer";
import WipPage from "./Pages/WorksInProgress"
import OtherWorksPage from "./Pages/OtherWorkPage";

const AppContainer = styled(Column)`
  min-height: 90vh;
  padding: 60px;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 0;
    padding: 30px 10px;
  }
`;

const Navbar = styled.nav`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-bottom: 20px;
  gap: 20px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const NavbarLink = styled(Link)`
  font-size: 2.0rem;
  text-decoration: none;
  color: #B7334D;
  font-weight: bold;

  &:hover {
    color: #C4665B;
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 0;
  }
  `;

const App: React.FC = () => {
  window.addEventListener("scroll", function () {
    document.body.style.backgroundPosition = `${window.scrollY * 0.05}px ${window.scrollY * 0.8}px`;
  });

  return (
    <Router>
      <AppContainer>
        <SelfSummary />

        <Navbar>
          <NavbarLink to="/">Games 🕹️</NavbarLink>
          <NavbarLink to="/wip">Works in progress 🚧</NavbarLink>
          <NavbarLink to="/other-work">Other work 🎨</NavbarLink>
          <NavbarLink to="/about-me">About me 👨🏻‍💻</NavbarLink>
          <NavbarLink to="/contact">Contact 💬</NavbarLink>
        </Navbar>

        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/wip" element={<WipPage />} />
          <Route path="/other-work" element={<OtherWorksPage/>}/>
        </Routes>
      </AppContainer>
      <Footer />
    </Router>
  );
};

export default App;
